<!--  Navbar Starts  -->

<div class="header-container fixed-top">
  <header class="header navbar navbar-expand-sm">
    <ul class="navbar-item theme-brand flex-row text-center">
      <li class="nav-item">
        <a
          href="javascript:void(0);"
          class="sidebarCollapse"
          data-placement="bottom"
        >
          <i class="las la-bars"></i>
        </a>
      </li>
    </ul>
    <ul class="navbar-item flex-row ml-md-0 ml-auto theme-brand">
      <li class="nav-item align-self-center d-md-none">
        <div
          class="d-flex flex-row align-center justify-content-center logo-area"
        >
          <a href="index.html" class="nav-link pr-0 pl-1">
            <img src="assets/img/logo.png" class="navbar-logo" alt="logo" />
          </a>
          <a href="index.html" class="nav-link pr-4 d-none d-md-block">
            Neptune
          </a>
        </div>
      </li>
    </ul>
    <ul class="navbar-item flex-row ml-md-auto">
      <!-- Primer <li> para la selección de empresa -->
      <li
        class="nav-item dropdown user-profile-dropdown"
        style="
          display: flex;
          align-items: center;
          min-width: 250px;
          justify-content: flex-end;
        "
      >
        <div
          *ngIf="isAdmin && !showSelectCompanyDropdown && !isLoadingCompanies"
          class="d-flex"
          style="gap: 0.5rem; cursor: pointer"
          (click)="showSelectCompanyMenu()"
        >
          <h6 class="font-13 mb-0 strong">{{ userCompany }}</h6>
          <i
            *ngIf="!showSelectCompanyDropdown && canSelectCompany"
            class="las la-angle-down"
            style="color: black"
          ></i>
        </div>
        <div
          class="select-company-menu"
          *ngIf="showSelectCompanyDropdown && !isLoadingCompanies"
        >
          <ng-select
            class="selectpicker"
            (change)="onSelectChange($event)"
            (close)="onSelectClose()"
            placeholder="Buscar cuenta..."
            bindLabel="label"
            bindValue="value"
            [items]="accountCompanies"
            [closeOnSelect]="true"
            [(ngModel)]="selectedCompany"
          ></ng-select>
        </div>
        <div
          class="d-flex justify-content-center loader"
          style="margin-right: 52px"
          *ngIf="isLoadingCompanies"
        >
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </li>

      <!-- Segundo <li> para el perfil de usuario -->
      <li
        class="nav-item dropdown user-profile-dropdown"
        style="display: flex; align-items: center"
      >
        <a
          href="javascript:void(0);"
          class="nav-link dropdown-toggle user"
          id="userProfileDropdown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
        >
          <div
            class="media align-center"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 2rem;
            "
          >
            <div class="media-content">
              <h6 class="font-13 mb-0 strong">{{ getUserName() }}</h6>
              <small>{{ currentEmail }}</small>
            </div>
          </div>
        </a>
        <div class="dropdown-menu position-absolute" style="width: 100%">
          <div class="nav-drop is-account-dropdown" style="width: 100%">
            <div class="inner">
              <div class="nav-drop-body account-items pb-0">
                <a class="account-item" (click)="editUser()">
                  <div class="media align-center">
                    <div class="icon-wrap">
                      <i class="las la-user font-20"></i>
                    </div>
                    <div class="media-content ml-3">
                      <h6 class="font-13 mb-0 strong">
                        Mi cuenta
                      </h6>
                    </div>
                  </div>
                </a>
                <hr class="account-divider" />
                <a class="account-item" href="" (click)="logout()">
                  <div class="media align-center">
                    <div class="icon-wrap">
                      <i class="las la-sign-out-alt font-20"></i>
                    </div>
                    <div class="media-content ml-3">
                      <h6 class="font-13 mb-0 strong">
                        Cerrar sesión
                      </h6>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </li>

      <li
        class="nav-item dropdown language-dropdown"
        style="margin-right: 45px"
      >
        <a
          href="javascript:void(0);"
          class="nav-link dropdown-toggle"
          id="language-dropdown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <img [src]="currentLanguageImage" class="flag-width" alt="flag" />
        </a>
        <div
          class="dropdown-menu position-absolute"
          aria-labelledby="language-dropdown"
          style
        >
          <a
            class="dropdown-item d-flex"
            (click)="changeSiteLanguage('en')"
            href="javascript:void(0);"
          >
            <img
              src="assets/img/flag/usa-flag.png"
              class="flag-width"
              alt="flag"
            />
            <span class="align-self-center">
              &nbsp;{{ 'header.english' | translate }}
            </span>
          </a>
          <a
            class="dropdown-item d-flex"
            (click)="changeSiteLanguage('es')"
            href="javascript:void(0);"
          >
            <img
              src="assets/img/flag/spain-flag.png"
              class="flag-width"
              alt="flag"
            />
            <span class="align-self-center">
              &nbsp;{{ 'header.spanish' | translate }}
            </span>
          </a>
        </div>
      </li>
    </ul>
  </header>
</div>
<!--  Navbar Ends  -->
<!--  Navbar Starts / Breadcrumb Area  -->
<div class="sub-header-container" *ngIf="!data || data.child">
  <header class="header navbar navbar-expand-sm">
    <ul class="navbar-nav flex-column">
      <li *ngIf="!data">
        <div class="page-header">
          <nav class="breadcrumb-one" aria-label="breadcrumb">
            <ol class="breadcrumb">
              <h1 style="letter-spacing: -1px; color: white">
                {{ 'home.hello' | translate }}
              </h1>
            </ol>
          </nav>
        </div>
      </li>
      <li *ngIf="!data">
        <div class="page-header">
          <nav class="breadcrumb-one" aria-label="breadcrumb">
            <ol class="breadcrumb d-flex flex-column">
              <h5 style="color: white; font-weight: 300">
                {{ 'home.caption' | translate }}
              </h5>
              <h5
                style="color: white; font-weight: 300; font-size: 1rem"
                *ngIf="!maintenanceMessage"
              >
                {{ 'home.lastSync' | translate }}: {{ lastSync || '-' }}
              </h5>
              <h5
                style="color: white; font-weight: 300; font-size: 1rem"
                *ngIf="maintenanceMessage"
              >
                {{ maintenanceMessage | translate }}
              </h5>
            </ol>
          </nav>
        </div>
      </li>

      <!-- SI HAY BREADCRUMB-->

      <li *ngIf="data">
        <div class="page-header">
          <nav class="breadcrumb-one" aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a routerLink="/home">{{ data.parent | translate }}</a>
              </li>
              <li class="breadcrumb-item" [class.active]="!data.grandchild">
                {{ data.child | translate }}
              </li>
              <li *ngIf="data.grandchild" class="breadcrumb-item active">
                {{ data.grandchild | translate }}
              </li>
            </ol>
            <h5
              class="page-title-header"
              *ngIf="data.description"
              style="color: white; font-weight: 300; margin-top: 1rem"
            >
              {{ data.description | translate }}
            </h5>
          </nav>
        </div>
      </li>
    </ul>
    <div *ngIf="showDatePeriod">
      <p class="text-white">
        {{ 'home.dataPeriod' | translate }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-info-icon lucide-info"
          data-toggle="tooltip"
          placement="top"
          animation="true"
          container="body"
          [openDelay]="300"
          [closeDelay]="300"
          ngbTooltip="{{ 'home.infoOcurrences' | translate }}"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4" />
          <path d="M12 8h.01" />
        </svg>
      </p>
      <div id="data-period" class="data-period" style="gap: 1rem">
        <input
          (click)="setDatePicker()"
          style="width: 238px"
          type="text"
          placeholder="Ingrese un rango de fecha"
          class="form-control"
          bsDaterangepicker
          [bsConfig]="{
            isAnimated: true,
            containerClass: 'theme-dark-blue test',
            adaptivePosition: true,
            rangeInputFormat: 'DD/MM/YYYY'
          }"
          [(ngModel)]="rangeDate"
          [ngModelOptions]="{ standalone: true }"
          [maxDate]="maxDateInput"
          (bsValueChange)="setDate($event)"
        />
        <div class="icon-refresh-date icon-date" (click)="sendDate()">
          <i class="las la-sync"></i>
        </div>
        <div style="display: none" class="icon-filter-date icon-date">
          <i class="las la-filter"></i>
        </div>
      </div>
    </div>
  </header>
</div>
<!--  Navbar Ends / Breadcrumb Area  -->
